import React from "react";
import Navbar from "../Components/Navbar";
import HeroSlider from "../Components/HeroSlider";
import ServicesGrid from '../Components/ServiceGrid';
import Component from "../Components/Values";
import { ExpertiseStats } from "../Components/ExpertiseStats";
import { WhyChooseUs } from "../Components/Whychoose";
import { IndustriesCarousel } from "../Components/Industries";
import TestimonialSection from "../Components/TestimonialSection";
import GetInTouchSection from "../Components/GetTouchSection";
import Footer from "../Components/Footer";
import WhatsAppButton from "../Components/WhatsappButton";

const Home = () => {
    return (
        <>
            <Navbar />
            <HeroSlider />
            <ExpertiseStats />

            <div className="min-h-screen bg-gray-50">
                <ServicesGrid />
            </div>
            {/* <Component /> */}
            <WhyChooseUs />
            <IndustriesCarousel />
            {/* <TestimonialSection /> */}
            <GetInTouchSection />
            <WhatsAppButton/>
            <Footer />
        </>
    );
}

export default Home;